import { HeaderProfile, SkeletonBox, LoadingContainer } from '@presentation/components';
import type { FC } from 'react';
import { MY_TIPAW_ROUTES } from '@application/constants';
import { useRouter } from '@application/utils';
import type { PageSkeletonProps } from './types';

export const PageSkeleton: FC<PageSkeletonProps> = () => {
  const { infoFromCurrentPath } = useRouter();

  if (MY_TIPAW_ROUTES.includes(infoFromCurrentPath.route)) {
    return <LoadingContainer style={{ minHeight: '80vh' }} />;
  }
  return (
    <>
      <HeaderProfile
        style={{ textAlign: 'center' }}
        title={<SkeletonBox style={{ width: '50%', height: '50px' }} />}
      />
      <LoadingContainer style={{ minHeight: '80vh' }} />
    </>
  );
};
